/**
 * `timezone.v1` — wire → canonical decoder for Timezone-shaped cells.
 *
 * Minimal today: the generated `SheetsNetwork.TimezoneCell` model validates
 * the `{ tz, transitions? }` shape. Timezone rendering is driven by the
 * row's `tz` attribute; this encoding reserves the cell payload for
 * future per-period data (e.g. DST transitions).
 *
 * Null return: missing `tz`, or a payload the model rejects.
 */

import type { EncodingDecoder } from "../core/encoding-registry.ts";
import { Json } from "../core/json.ts";
import { SheetsNetwork } from "../wire/rows-network.ts";
import type { CellValue } from "../core/dtype.ts";
import type { Option } from "../core/option.ts";

/** The `timezone.v1` wire-encoding name a timezone source row declares in its metadata. */
export const TIMEZONE_V1 = "timezone.v1";

/** Decodes a `timezone.v1` wire cell to a canonical timezone value (`null`: not one). */
export const timezoneV1: EncodingDecoder = (wire): Option<Json | CellValue> => {
  const raw = Json.object(Json.wire(wire));
  if (raw == null) return null;
  const result = SheetsNetwork.TimezoneCell.safeHydrate(raw);
  return result.isOk ? result.value : null;
};
